<template>
  <div style="padding: 0">

    <mu-flexbox-item style="padding: 8px 8px 4px 8px" class="subHeader">
      <div>Select one of your pre-saved meals from the list</div>
    </mu-flexbox-item>


    <mu-list class="oddEven">
      <mu-list-item
        disableRipple
        v-for="meal, index in meals"
        :key="'meal-' + index "
        @click="loadFoods"

      >
        <div slot="title" v-once @click="loadMeal(meal)">{{meal.meal_name}}</div>
        <div slot="describe" @click="loadMeal(meal)">
          Contains {{meal.count}} foods
        </div>

        <mu-icon-menu slot="right" icon="more_vert" :scroller="scroller">
          <mu-menu-item :title="$t('message.deleteText')" @click.native="deleteMeal(meal.meal_id)"/>
        </mu-icon-menu>


      </mu-list-item>
    </mu-list>

  </div>
</template>

<script>


  import FoodApi from '../../../api/Food'


  export default {
    name: "my-meals",
    props: {
      title: {
        type: String,
        default: "Breakfast"
      },

      date: {
        type: Object
      }
    },
    data() {
      return {
        meals: [],
        mealTypeId: 1,
      }
    },
    mounted() {
      let self = this;
      self.mealTypeId = self.$route.query.mealTypeId;
      FoodApi.getFavorites()
        .then(function (response) {
          self.meals = response.data;
        });
    },
    methods: {
      loadMeal(meal) {
        let self = this;
        let date = moment(self.date)
        if (self.mealTypeId === 1) {
          date.set({
            'hour': 9,
            'minute': 0,
            'second': 0
          })
        }

        if (self.mealTypeId === 2) {
          date.set({
            'hour': 12,
            'minute': 0,
            'second': 0
          })
        }

        if (self.mealTypeId === 3) {
          date.set({
            'hour': 18,
            'minute': 0,
            'second': 0
          })
        }
        self.isLoading = true;

        FoodApi.addFoods({
          date: date.format(),
          meal_type_id: self.mealTypeId,
          foods: meal.foods,
          recipes: meal.recipes
        })
          .then(function (response) {
            self.$toastr.success(self.$t('message.labelSuccess'));


            self.$router.replace({
              name: 'FoodDiary',
              query: {
                date: moment(self.date).format('YYYY-MM-DD')
              }
            });
          })
          .catch(function () {
            self.isLoading = false;
          })
      },
      deleteMeal(mealId) {
        let self = this;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return FoodApi.deleteFavorite(mealId)
          }
        })
          .then(function () {
            const index = self.meals.findIndex(obj => obj.meal_id === mealId);
            if (index !== -1) self.meals.splice(index, 1);
            self.$toastr.success(self.$t('message.foodDiaryMealPlateRemoved'))
          })


      },
    }
  }
</script>

<style>
  div#food-diary-my-meals {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// MyMeals.vue?681aa4ca